<template>
    <div class="home">
        <!--<Header ></Header>-->
        <main>
            <search-article/>
            <blog-item/>
        </main>
    </div>
</template>

<script>
    // @ is an alias to /src
    import BlogItem from '@/components/BlogItem'
    import SearchArticle from '@/components/SearchArticle'

    export default {
        name: 'home',
        components: {
            BlogItem,
            SearchArticle
        },
        mounted() {
            // setTimeout(()=> {
            this.$eventHub.$emit('filter-data-visible', true)
            // },200)
        },
        data() {
            return {}
        }
    }
</script>
<style>

</style>
